
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import ItemTags from '@/components/shared/ItemTags.vue';

@Component<MenuCardVertical>({ components: { ItemTags } })

export default class MenuCardVertical extends Vue {
	@Prop({ type: Object, required: true, default: () => {} }) private menuItem!: MenuItem;
	@Prop({ type: Boolean, required: false, default: false }) private showImage!: boolean;
	@Prop({ type: String, required: false, default: null }) private imageURL!: string;
	@Prop({ type: String, required: false, default: null }) private formattedDescription!: string;
	@Getter('hidePricing', { namespace: 'restaurant' }) private hidePricing!: boolean;
}
